import { Card } from "react-bootstrap";
import "./style.css";

const SpanishTerms = () => {
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          marginTop: "-1rem",
        }}
        className="padding bg-green-light-cu pt-5"
      >
        <p className="text-center text-green" style={{ fontWeight: "500" }}>
          Última actualización:
          <span style={{ fontWeight: "400" }}> Octubre 2025</span>
        </p>

        <h1 className="text-center text-green">Términos y Condiciones</h1>

        <p className="text-center">
          La contratación de los servicios de{" "}
          <span style={{ fontWeight: "600" }}>carrosacentroamerica.com</span> de
          forma escrita, telefónica u oral se regirá por el siguiente acuerdo
          y/o Términos & Condiciones.
        </p>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>1. DEFINICIÓN Y ALCANCE</h4>
          <p>
            GARLAS LLC actúa como agente logístico y corredor autorizado para
            coordinar transporte terrestre y marítimo de vehículos, motocicletas
            y embarcaciones dentro de Estados Unidos, hacia/desde Puerto Rico y
            hacia Centroamérica (Guatemala, Honduras y El Salvador). GARLAS no
            es un transportista directo, sino un intermediario logístico
            (broker) debidamente registrado ante el DOT y FMCSA.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>2. SERVICIOS Y LIMITACIÓN DE RESPONSABILIDAD</h4>
          <p>
            GARLAS coordina el transporte con transportistas terrestres y
            marítimos certificados, pero nunca toma posesión del vehículo. La
            responsabilidad directa sobre daños o retrasos recae en el carrier o
            naviera que efectúa el transporte. En rutas marítimas aplican los
            términos del Bill of Lading de la naviera. No se garantizan fechas
            exactas de recogida o entrega.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>3. RESPONSABILIDAD DEL CLIENTE</h4>
          <p>
            El cliente debe proporcionar información exacta del vehículo,
            prepararlo adecuadamente, entregar documentación válida, estar
            presente o designar a un representante, inspeccionar y firmar el
            Bill of Lading, y notificar reclamos en 48 horas tras la entrega.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>4. VEHÍCULOS INOPERABLES Y MODIFICADOS</h4>
          <p>
            Deben notificarse al momento de la reserva. Vehículos con
            alteraciones o tamaño mayor pueden generar cargos adicionales o ser
            rechazados. Si un vehículo operable se vuelve inoperable, el cliente
            asumirá el recargo de winch o manejo especial.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>5. OBJETOS PERSONALES Y ARTÍCULOS PROHIBIDOS</h4>
          <p>
            No se permiten pertenencias personales dentro del vehículo (solo
            accesorios fijos). Se prohíben armas, líquidos inflamables, drogas,
            dinero o documentos. Cualquier objeto no declarado viaja bajo riesgo
            del cliente y puede causar la retención del vehículo por
            autoridades.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>6. CANCELACIONES Y REEMBOLSOS</h4>
          <p>
            Cancelaciones antes de asignar un carrier: sin costo. Después de la
            asignación o despacho: tarifa mínima $150 USD. Si el vehículo fue
            cargado o entregado al transportista: aplica cargo adicional. Las
            cancelaciones deben hacerse por correo electrónico a
            info@shipshippersusa.com.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>7. PAGOS Y CARGOS</h4>
          <p>
            Pagos totales antes del embarque o según orden. Pagos C.O.D. deben
            ser en efectivo, money order o cashier's check. Si el cliente no
            recibe o paga, el vehículo podrá ser almacenado a su costo. Facturas
            vencidas acumulan 1.5% de interés mensual.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>8. SEGUROS</h4>
          <p>
            Doméstico USA: seguro incluido (FMCSA). | USA↔PR: opcional $100
            (25k) / $200 (50k) con deducible $1,000. | USA→Centroamérica: no
            disponible. GARLAS recomienda seguro marítimo opcional para autos de
            valor superior a $15,000 USD.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>9. RECLAMOS POR PÉRDIDA, DAÑO O RETRASO</h4>
          <p>
            GARLAS no es responsable por daños o pérdidas. Reclamos deben
            presentarse directamente al carrier o naviera conforme a la ley
            (Carmack Amendment o Carriage of Goods by Sea Act). GARLAS asistirá
            con la información necesaria.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>10. LIMITACIÓN DE RESPONSABILIDAD</h4>
          <p>
            La responsabilidad máxima de GARLAS por cualquier reclamo no
            excederá el valor pagado por sus servicios de intermediación. No
            garantiza ganancias, tiempos de entrega ni condiciones futuras del
            mercado.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>11. INDEMNIZACIÓN</h4>
          <p>
            El cliente indemniza a GARLAS ante cualquier reclamo o pérdida
            derivada de información falsa, violaciones de ley o daños causados
            por artículos no autorizados.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>12. LEY APLICABLE Y JURISDICCIÓN</h4>
          <p>
            Este acuerdo se rige por las leyes del Estado de Florida. Las
            disputas se resolverán en los tribunales del Condado de Miami-Dade,
            salvo arbitraje acordado. En Puerto Rico o Centroamérica aplican
            leyes marítimas locales.
          </p>
        </Card>

        <Card className="bg-card-blue-light py-4 px-3 text-green mb-3">
          <h4>13. RELACIÓN CONTRACTUAL</h4>
          <p>
            Nada constituye sociedad o empleo entre las partes. GARLAS y el
            cliente actúan como entidades independientes. Estos términos
            reemplazan cualquier acuerdo previo.
          </p>
        </Card>

        <Card className="bg-green-light-cu-2 py-4 px-3 text-green mb-3">
          <h4>14. DERECHOS DE IMAGEN Y PROMOCIÓN</h4>
          <p>
            GARLAS podrá usar el nombre o logo del cliente como referencia
            comercial, salvo que el cliente lo rechace por correo a
            privacy@shipshippersusa.com.
          </p>
        </Card>

        <Card className=" py-4 px-3 text-green"></Card>
      </div>
      <div
        className="bg-green-light-cu-2 text-green py-4 padding"
        style={{ minHeight: "200px" }}
      >
        <h4 style={{ fontWeight: "600" }}>RESUMEN LEGAL SIMPLIFICADO</h4>
        <p>
          GARLAS actúa como intermediario autorizado, no transportista. Los
          tiempos son estimados, las cancelaciones generan cargos
          administrativos, el seguro marítimo es opcional, y las reclamaciones
          se presentan directamente al carrier o naviera.
        </p>
      </div>
    </>
  );
};

export default SpanishTerms;
